import Axios from "api/axios"
import { history } from "app-history"

export const getProfile = async () => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'GET',
      url: '/profile',
    })
    return result.data;
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const updateProfile = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PATCH',
      url: '/profile',
      data: form,
    })
    return result.data;
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const shareProfile = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'POST',
      url: '/profile/share',
      data: form,
    })
    history.push('/app/shared')
    return result.data;
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const getMembers = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'GET',
      url: '/members',
      data: form,
    })
    return result.data;
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const createMember = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PUT',
      url: '/members',
      data: form,
    })
    return result.data;
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const updateMember = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PATCH',
      url: '/members',
      data: form,
    })
    return result.data;
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const deleteMember = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'DELETE',
      url: '/members',
      data: form,
    })
    return result.data;
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const getReferences = async (form) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'GET',
      url: '/references',
      data: form,
    })
    return result.data;
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const createMemberReferences = async (form) => {
  Object.keys(form).forEach((key) => {
    if (typeof form[key] === 'string') form[key] = form[key].trim()
  })

  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PUT',
      url: '/references',
      data: {
        ...form,
        templateId: parseInt(form.templateId),
        contactType: form.noLinkedin ? 'Mobile' : 'LinkedIn',
        // companyReferral
      }
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}
